<template>
  <CreateEditClientModal
    v-if="showCreateEditClientModal"
    :clientId="clientIdSelected"
    @closeModal="closeModal"
  />
  <ContactsClientModal
    v-if="showContactsClientModal"
    :clientId="clientIdSelected"
    @closeModal="closeModal"
  />
  <FinalizeClientModal
    v-if="showFinalizeClientModal"
    :clientId="clientIdSelected"
    @closeModal="closeModal"
  />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Clientes</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Gerencie os clientes
      </span>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-primary ms-2"
          title="Sincronizar Cliente"
          :disabled="isSyncingClients"
          @click="syncClients"
        >
          <span v-if="isSyncingClients">
            <i class="ph ph-spinner spinner me-2" /> Sincronizando Clientes
          </span>
          <span v-else>Sincronizar Clientes</span>
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListClients
      v-else
      :clients="clients"
      @createEditClient="createEditClient"
      @contactsClient="contactsClient"
      @finalizeClient="finalizeClient"
    />
  </div>
</template>

<script>
import CreateEditClientModal from '@/components/clients/CreateEditClientModal.vue'
import ContactsClientModal from '@/components/clients/ContactsClientModal.vue'
import FinalizeClientModal from '@/components/clients/FinalizeClientModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListClients from '@/components/clients/ListClients.vue'

export default {
  name: 'Clients',

  components: {
    CreateEditClientModal,
    ContactsClientModal,
    FinalizeClientModal,
    LoadingData,
    ListClients,
  },

  data() {
    return {
      isLoadingData: true,
      isSyncingClients: false,
      showCreateEditClientModal: false,
      showContactsClientModal: false,
      showFinalizeClientModal: false,
      clients: [],
      clientIdSelected: null,
    }
  },

  methods: {
    async getClients() {
      try {
        this.isLoadingData = true
        this.clients = await this.$store.dispatch('getClients')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async syncClients() {
      try {
        this.isSyncingClients = true

        const response = await this.$store.dispatch('syncClients')
        this.$root.$refs.notification.success(response.message)

        this.getClients()
        this.isSyncingClients = false
      } catch (error) {
        this.isSyncingClients = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditClient(clientId) {
      this.clientIdSelected = clientId || null
      this.showCreateEditClientModal = true
    },

    contactsClient(clientId) {
      this.clientIdSelected = clientId
      this.showContactsClientModal = true
    },

    finalizeClient(clientId) {
      this.clientIdSelected = clientId
      this.showFinalizeClientModal = true
    },

    closeModal(needReload) {
      if (needReload) {
        this.getClients()
      }
      this.showCreateEditClientModal = false
      this.showContactsClientModal = false
      this.showFinalizeClientModal = false
    },
  },

  mounted() {
    this.getClients()
  },
}
</script>
